import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';
import { Flip } from 'gsap/Flip';
import './Beginners.css';
import Lenis from '@studio-freight/lenis'; // ✅ Static import
import BegHomeAdv from '../Course/Advance/pages/HomeAdv';
import SEO from '../SEO/SEO';
gsap.registerPlugin(ScrollTrigger, CustomEase, Flip);

function AdvanceCourse() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1,
      orientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 1.5,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
      useOverscroll: true,
      useControls: true,
      useAnchor: true,
      useRaf: true,
      infinite: false
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  return (
    <div className="App">
      <SEO
  title="Advanced English Course | Boldly English"
  description="Master advanced English with fluent speaking, professional communication, advanced vocabulary, presentations, debates, and real-world conversations."
 canonical="https://boldlyenglish.com/advanced"
 />
      <div className="transition">
        <div className="transition-inner"></div>
      </div>
      <BegHomeAdv />
    </div>
  );
}

export default AdvanceCourse;
